<template>
  <b-row class="dashboard-indicadores-historico-rentabilidad-neta">
    <b-col cols="12">
      <label class="titulo" v-if="showTitulo">{{ titulo }}</label>
      <b-table hover
          responsive="sm" 
          class="registro"
          :busy="tableBusy"
          :items="indicadoresRentabilidadNeta" 
          :fields="indicadoresRentabilidadNetaFields">
        <div slot="table-busy" class="text-center">
          <b-spinner class="table-spinner" label="Spinning" />
        </div>
        <template v-slot:cell(pjeObjetivo)="data">
          {{ data.item.pjeObjetivo | porcentaje }}
        </template>
        <template v-slot:cell(costoTotal)="data">
          {{ data.item.costoTotal | moneda }}
        </template>
        <template v-slot:cell(cotizacionTotal)="data">
          {{ data.item.cotizacionTotal | moneda }}
        </template>
        <template v-slot:cell(pjeRentabilidad)="data">
          {{ data.item.pjeRentabilidad | porcentaje }}
        </template>
        <template v-slot:cell(rentabilidad)="data">
          {{ (data.item.cotizacionTotal - data.item.costoTotal) | moneda }}
        </template>

        <template v-slot:cell(detailShowing)="row">
          <b-btn class="detailShowing" 
              size="sm" 
              @click.stop="row.toggleDetails">
            {{ ( row.detailsShowing) ? '-' : '+' }}
          </b-btn>            
        </template>

        <template v-slot:row-details="row">
          <b-row>
            <b-col cols="12">
              <p>Información del Indicador:</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="2">
              <p class="descripcion">Ventas</p>
            </b-col>
            <b-col cols="2">
              <p class="descripcion">{{ row.item.ventas | moneda }}</p>
            </b-col>
            <b-col cols="8">
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="2">
              <p class="descripcion">Ventas - Dif.Cambio</p>
            </b-col>
            <b-col cols="2">
              <p class="descripcion">{{ row.item.diferenciaCambioVentas | moneda }}</p>
            </b-col>
            <b-col cols="8">
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="2">
              <p class="descripcion">Inversiones</p>
            </b-col>
            <b-col cols="2">
              <p class="descripcion">{{ row.item.inversiones | moneda }}</p>
            </b-col>
            <b-col cols="8">
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="2">
              <p class="descripcion">Compras</p>
            </b-col>
            <b-col cols="2">
              <p class="descripcion">{{ row.item.compras | moneda }}</p>
            </b-col>
            <b-col cols="8">
              <p class="descripcion">{{ row.item.compras / row.item.cotizacionTotal * 100 | porcentaje }}</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="2">
              <p class="descripcion">Gastos</p>
            </b-col>
            <b-col cols="2">
              <p class="descripcion">{{ row.item.gastos | moneda }}</p>
            </b-col>
            <b-col cols="8">
              <p class="descripcion">{{ row.item.gastos / row.item.cotizacionTotal * 100 | porcentaje }}</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="2">
              <p class="descripcion">Sueldos</p>
            </b-col>
            <b-col cols="2">
              <p class="descripcion">{{ row.item.sueldos | moneda }}</p>
            </b-col>
            <b-col cols="8">
              <p class="descripcion">{{ row.item.sueldos / row.item.cotizacionTotal * 100 | porcentaje }}</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="2">
              <p class="descripcion">Impuestos</p>
            </b-col>
            <b-col cols="2">
              <p class="descripcion">{{ row.item.impuestos | moneda }}</p>
            </b-col>
            <b-col cols="8">
              <p class="descripcion">{{ row.item.impuestos / row.item.cotizacionTotal * 100 | porcentaje }}</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="2">
              <p class="descripcion">Gastos Bcos.</p>
            </b-col>
            <b-col cols="2">
              <p class="descripcion">{{ row.item.gastosBancarios | moneda }}</p>
            </b-col>
            <b-col cols="8">
              <p class="descripcion">{{ row.item.gastosBancarios / row.item.cotizacionTotal * 100 | porcentaje }}</p>
            </b-col>
          </b-row>
          <b-row v-if="totalNegocio">
            <b-col cols="2">
              <p class="descripcion">Premios/Reembolsos</p>
            </b-col>
            <b-col cols="2">
              <p class="descripcion">{{ row.item.premiosReembolsos | moneda }}</p>
            </b-col>
            <b-col cols="8">
              <p class="descripcion">{{ row.item.premiosReembolsos / row.item.cotizacionTotal * 100 | porcentaje }}</p>
            </b-col>
          </b-row>
          <b-row v-if="totalNegocio">
            <b-col cols="2">
              <p class="descripcion">Deuda Comercial</p>
            </b-col>
            <b-col cols="2">
              <p class="descripcion">{{ row.item.deudaComercial | moneda }}</p>
            </b-col>
            <b-col cols="8">
              <p class="descripcion">{{ row.item.deudaComercial / row.item.cotizacionTotal * 100 | porcentaje }}</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="2">
              <p class="descripcion">Compras - Dif.Cambio</p>
            </b-col>
            <b-col cols="2">
              <p class="descripcion">{{ row.item.diferenciaCambioCompras | moneda }}</p>
            </b-col>
            <b-col cols="8">
              <p class="descripcion">{{ row.item.diferenciaCambioCompras / row.item.cotizacionTotal * 100 | porcentaje }}</p>
            </b-col>
          </b-row>
        </template>

        <template v-slot:cell(opciones)="data">
          <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
            <template slot="button-content">
              <i class="fa fa-ellipsis-v"></i>
            </template>

            <b-dropdown-item 
                @click.stop="exportarVentas(data.item)">
              <i class="fa fa-file-excel-o"></i>Exportar Ventas</b-dropdown-item>
            <b-dropdown-item 
                @click.stop="exportarInversionesBancos(data.item)">
              <i class="fa fa-file-excel-o"></i>Exportar Inversiones - Bancos</b-dropdown-item>
            <b-dropdown-item 
                @click.stop="exportarCompras(data.item)">
              <i class="fa fa-file-excel-o"></i>Exportar Compras</b-dropdown-item>
            <b-dropdown-item 
                @click.stop="exportarGastos(data.item)">
              <i class="fa fa-file-excel-o"></i>Exportar Gastos</b-dropdown-item>
            <b-dropdown-item 
                @click.stop="exportarSueldos(data.item)">
              <i class="fa fa-file-excel-o"></i>Exportar Sueldos</b-dropdown-item>
            <b-dropdown-item 
                @click.stop="exportarImpuestos(data.item)">
              <i class="fa fa-file-excel-o"></i>Exportar Impuestos</b-dropdown-item>
            <b-dropdown-item 
                @click.stop="exportarGastosBancarios(data.item)">
              <i class="fa fa-file-excel-o"></i>Exportar Gastos Bancarios</b-dropdown-item>
            <b-dropdown-item 
                @click.stop="exportarImpuestosBancos(data.item)">
              <i class="fa fa-file-excel-o"></i>Exportar Impuestos - Bancos</b-dropdown-item>
            <b-dropdown-item 
                @click.stop="exportarInteresesPlanesPagosBancos(data.item)">
              <i class="fa fa-file-excel-o"></i>Exportar Intereses Planes de Pagos - Bancos</b-dropdown-item>
            <b-dropdown-item v-if="totalNegocio"
                @click.stop="exportarTransferenciasPremios(data.item)">
              <i class="fa fa-file-excel-o"></i>Exportar Premios/Reembolsos</b-dropdown-item>
            <b-dropdown-item v-if="totalNegocio"
                @click.stop="exportarComprasReembolsos(data.item)">
              <i class="fa fa-file-excel-o"></i>Exportar Compras x Reembolsos</b-dropdown-item>
            <b-dropdown-item v-if="totalNegocio"
                @click.stop="exportarDeudaComercial(data.item)">
              <i class="fa fa-file-excel-o"></i>Exportar Deuda Comercial</b-dropdown-item>
            <b-dropdown-item v-if="totalNegocio"
                @click.stop="exportarVentasDeudaComercial(data.item)">
              <i class="fa fa-file-excel-o"></i>Exportar Ventas Deuda Comercial</b-dropdown-item>
            <b-dropdown-item 
                @click.stop="exportarVentasDiferenciasCambio(data.item)">
              <i class="fa fa-file-excel-o"></i>Exportar Diferencias de Cambio en Ventas</b-dropdown-item>
            <b-dropdown-item 
                @click.stop="exportarComprasDiferenciasCambio(data.item)">
              <i class="fa fa-file-excel-o"></i>Exportar Diferencias de Cambio en Compras</b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
    </b-col>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </b-row>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs';

export default {
  components: {
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  props: {
    semestral: {
      type: Boolean,
      default: true
    },
    totalNegocio: {
      type: Boolean,
      default: false
    },
    showTitulo: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      indicadoresRentabilidadNeta: [],
      indicadoresRentabilidadNetaFields: [
        {
            key: 'detailShowing',
            label: '',
            class: 'text-center'
        },
        { 
          key: 'indicadorPeriodo',
          label: 'Periodo' 
        },
        { 
          key: 'pjeObjetivo',
          class: 'text-right'
        },
        // { 
        //   key: 'compras',
        //   class: 'text-right'
        // },
        // { 
        //   key: 'sueldos',
        //   class: 'text-right'
        // },
        // { 
        //   key: 'impuestos',
        //   class: 'text-right'
        // },
        // { 
        //   key: 'gastosBancarios',
        //   class: 'text-right'
        // },
        // { 
        //   key: 'premiosReembolsos',
        //   class: 'text-right'
        // },
        { 
          key: 'costoTotal',
          class: 'text-right'
        },
        { 
          key: 'cotizacionTotal',
          class: 'text-right'
        },
        { 
          key: 'pjeRentabilidad',
          label: 'RN - %',
          class: 'text-right'
        },
        { 
          key: 'rentabilidad',
          label: 'RN - $',
          class: 'text-right'
        },
        { 
          key: 'descripcion',
          label: 'Descripción'
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        }
      ],

      tableBusy: false
    }
  },
  computed: {
    titulo() {
      if (this.semestral) {
          return `Rentabilidad Neta Semestral - ${!this.totalNegocio? 'Sin Reembolsos' : ''}`;
      } else {
        return `Rentabilidad Neta Anual - ${!this.totalNegocio? 'Sin Reembolsos' : ''}`;
      }
      // if (this.semestral) {
      //     return `Rentabilidad Neta Semestral${this.totalNegocio? ' - Total Negocio' : ''}`;
      // } else {
      //   return `Rentabilidad Neta Anual${this.totalNegocio? ' - Total Negocio' : ''}`;
      // }
    }
  },
  methods: {
    getIndicadores() {
      let dispatch = '';
      let getter = '';

      if (this.semestral) {
        dispatch = 'resultadosRentabilidadNeta/getIndicadoresRentabilidadNetaSemestralHistorico';
        getter = 'resultadosRentabilidadNeta/indicadoresRentabilidadNetaSemestralHistorico';

        if ( (/true/i).test(this.totalNegocio)) {
          dispatch = 'resultadosRentabilidadNeta/getIndicadoresRentabilidadNetaSemestralTotalHistorico';
          getter = 'resultadosRentabilidadNeta/indicadoresRentabilidadNetaSemestralTotalHistorico';
        }
      } else {
        dispatch = 'resultadosRentabilidadNeta/getIndicadoresRentabilidadNetaAnualHistorico';
        getter = 'resultadosRentabilidadNeta/indicadoresRentabilidadNetaAnualHistorico';

        if ( (/true/i).test(this.totalNegocio)) {
          dispatch = 'resultadosRentabilidadNeta/getIndicadoresRentabilidadNetaAnualTotalHistorico';
          getter = 'resultadosRentabilidadNeta/indicadoresRentabilidadNetaAnualTotalHistorico';
        }
      }

      this.tableBusy = true;
      this.$store.dispatch(dispatch)
        .then(() => {
          this.indicadoresRentabilidadNeta = this.$store.getters[getter];
          this.tableBusy = false;
        });
    },

    exportarVentas(item) {
      let params = {
        fechaDesde: item.fechaDesde,
        fechaHasta: item.fechaHasta,
        totalNegocio: this.totalNegocio
      }
      this.showSpinner();
      this.$store.dispatch('resultadosRentabilidadNeta/getVentasIndicadorRentabilidadNetaHistorico', params)
        .then(() => {
          let exportXls = Boolean(false); 
          let ventas = this.$store.getters['resultadosRentabilidadNeta/resultadosIndicadorRentabilidadNeta'];

          if (ventas) {
            if (ventas.length != 0) {
              exportXls = Boolean(true);
            }
          }
          if (exportXls) {
            let title= 'Detalle de Ventas';
            let fileName = 'ventas';
            let format = [
              { titulo: 'Fecha Comprobante', nombre: 'fechaComprobante', formato: 'fecha' },
              { titulo: 'Fecha Imputacion', nombre: 'fechaImputacionIndicadores', formato: 'fecha' },
              { titulo: 'Cliente', nombre: 'cliente', formato: '' },
              { titulo: 'Comprobante', nombre: 'comprobante', formato: '' },
              { titulo: 'Número', nombre: 'numeroCompleto', formato: '' },
              { titulo: 'Moneda', nombre: 'moneda', formato: '' },
              { titulo: 'Total', nombre: 'total', formato: '' },
              { titulo: 'Neto', nombre: 'montoNeto', formato: '' },
              { titulo: 'Neto Reembolsos', nombre: 'montoNetoReembolsos', formato: '' }
            ];

            this.exportXLS(title, fileName, ventas, format);
          } else {
            this.showModalMsj('No hay datos para exportar', null, null, 'light')
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    exportarCompras(item) {
      let params = {
        fechaDesde: item.fechaDesde,
        fechaHasta: item.fechaHasta,
        totalNegocio: this.totalNegocio
      }
      this.showSpinner();
      this.$store.dispatch('resultadosRentabilidadNeta/getComprasIndicadorRentabilidadNetaHistorico', params)
        .then(() => {
          let exportXls = Boolean(false); 
          let compras = this.$store.getters['resultadosRentabilidadNeta/resultadosIndicadorRentabilidadNeta'];

          if (compras) {
            if (compras.length != 0) {
              exportXls = Boolean(true);
            }
          }
          if (exportXls) {
            let title= 'Detalle de Compras';
            let fileName = 'compras';
            // let title= 'Detalle de Compras-Gastos';
            // let fileName = 'compras-gastos';
            let format = [
              { titulo: 'Proveedor', nombre: 'proveedor', formato: '' },
              { titulo: 'Fecha', nombre: 'fechaComprobante', formato: 'fecha' },
              { titulo: 'Comprobante', nombre: 'comprobante', formato: '' },
              { titulo: 'Moneda', nombre: 'moneda', formato: '' },
              { titulo: 'Total Comprobante Moneda Original', nombre: 'totalComprobante', formato: '' },
              { titulo: 'Total Comprobante Pesos', nombre: 'totalComprobantePesos', formato: '' },
              { titulo: 'Neto Comprobante', nombre: 'montoNetoComprobante', formato: '' },
              // { titulo: 'Neto Gastos Producción', nombre: 'montoNetoCuentasProduccion', formato: '' },
              { titulo: 'Neto Ordenes Proveedores', nombre: 'montoNetoOrdenesProveedores', formato: '' },
              { titulo: 'Neto Remitos', nombre: 'montoNetoRemitos', formato: '' },
              { titulo: 'Neto Viáticos', nombre: 'montoNetoViaticos', formato: '' },
              { titulo: 'Amortización - Años', nombre: 'amortizacionAnios', formato: '' }
            ];

            this.exportXLS(title, fileName, compras, format);
          } else {
            this.showModalMsj('No hay datos para exportar', null, null, 'light')
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    exportarGastos(item) {
      let params = {
        fechaDesde: item.fechaDesde,
        fechaHasta: item.fechaHasta,
        totalNegocio: this.totalNegocio
      }
      this.showSpinner();
      this.$store.dispatch('resultadosRentabilidadNeta/getGastosIndicadorRentabilidadNetaHistorico', params)
        .then(() => {
          let exportXls = Boolean(false); 
          let compras = this.$store.getters['resultadosRentabilidadNeta/resultadosIndicadorRentabilidadNeta'];

          if (compras) {
            if (compras.length != 0) {
              exportXls = Boolean(true);
            }
          }
          if (exportXls) {
            let title= 'Detalle de Gastos';
            let fileName = 'gastos';
            let format = [
              { titulo: 'Proveedor', nombre: 'proveedor', formato: '' },
              { titulo: 'Fecha', nombre: 'fechaComprobante', formato: 'fecha' },
              { titulo: 'Comprobante', nombre: 'comprobante', formato: '' },
              { titulo: 'Moneda', nombre: 'moneda', formato: '' },
              { titulo: 'Total Comprobante Moneda Original', nombre: 'totalComprobante', formato: '' },
              { titulo: 'Total Comprobante Pesos', nombre: 'totalComprobantePesos', formato: '' },
              { titulo: 'Neto Comprobante', nombre: 'montoNetoComprobante', formato: '' },
              { titulo: 'Neto Gastos', nombre: 'montoNetoCuentasGastos', formato: '' },
              { titulo: 'Neto Ordenes Internas', nombre: 'montoNetoOrdenesProveedoresInternas', formato: '' },
              { titulo: 'Neto Remitos Internos', nombre: 'montoNetoRemitosInternos', formato: '' },
              { titulo: 'Amortización - Años', nombre: 'amortizacionAnios', formato: '' }
            ];

            this.exportXLS(title, fileName, compras, format);
          } else {
            this.showModalMsj('No hay datos para exportar', null, null, 'light')
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    exportarSueldos(item) {
      let params = {
        fechaDesde: item.fechaDesde,
        fechaHasta: item.fechaHasta,
        totalNegocio: this.totalNegocio
      }
      this.showSpinner();
      this.$store.dispatch('resultadosRentabilidadNeta/getSueldosIndicadorRentabilidadNetaHistorico', params)
        .then(() => {
          let exportXls = Boolean(false); 
          let sueldos = this.$store.getters['resultadosRentabilidadNeta/resultadosIndicadorRentabilidadNeta'];

          if (sueldos) {
            if (sueldos.length != 0) {
              exportXls = Boolean(true);
            }
          }
          if (exportXls) {
            let title= 'Detalle de Sueldos';
            let fileName = 'sueldos';
            let format = [
              { titulo: 'Periodo/Fecha Liq.', nombre: 'periodo', formato: 'fecha' },
              { titulo: 'SAC', nombre: 'sac', formato: 'bool' },
              { titulo: 'Liquidación', nombre: 'liquidacionFinal', formato: 'bool' },
              // { titulo: 'Personal', nombre: 'personal', formato: '' },
              { titulo: 'Honorarios', nombre: 'importeHonorarios', formato: 'importe' },
              { titulo: 'Adicional', nombre: 'importeAdicional', formato: 'importe' },
              { titulo: 'Otros Conceptos', nombre: 'importeOtrosConceptos', formato: 'importe' },
              { titulo: 'Liq. Final', nombre: 'importeLiquidacionFinal', formato: 'importe' },
            ];

            this.exportXLS(title, fileName, sueldos, format);
          } else {
            this.showModalMsj('No hay datos para exportar', null, null, 'light')
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    exportarImpuestos(item) {
      let params = {
        fechaDesde: item.fechaDesde,
        fechaHasta: item.fechaHasta,
        totalNegocio: this.totalNegocio
      }
      this.showSpinner();
      this.$store.dispatch('resultadosRentabilidadNeta/getImpuestosIndicadorRentabilidadNetaHistorico', params)
        .then(() => {
          let exportXls = Boolean(false); 
          let impuestos = this.$store.getters['resultadosRentabilidadNeta/resultadosIndicadorRentabilidadNeta'];

          if (impuestos) {
            if (impuestos.length != 0) {
              exportXls = Boolean(true);
            }
          }
          if (exportXls) {
            let title= 'Detalle de Impuestos';
            let fileName = 'impuestos';
            let format = [
              { titulo: 'Fecha', nombre: 'fechaComprobante', formato: 'fecha' },
              { titulo: 'Organismo', nombre: 'organismo', formato: '' },
              { titulo: 'Impuesto', nombre: 'impuesto', formato: '' },
              { titulo: 'Periodo', nombre: 'periodo', formato: 'fecha' },
              { titulo: 'Importe', nombre: 'importe', formato: 'importe' },
            ];

            this.exportXLS(title, fileName, impuestos, format);
          } else {
            this.showModalMsj('No hay datos para exportar', null, null, 'light')
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    exportarGastosBancarios(item) {
      let params = {
        fechaDesde: item.fechaDesde,
        fechaHasta: item.fechaHasta,
        totalNegocio: this.totalNegocio
      }
      this.showSpinner();
      this.$store.dispatch('resultadosRentabilidadNeta/getGastosBancariosIndicadorRentabilidadNetaHistorico', params)
        .then(() => {
          let exportXls = Boolean(false); 
          let gastosBancarios = this.$store.getters['resultadosRentabilidadNeta/resultadosIndicadorRentabilidadNeta'];

          if (gastosBancarios) {
            if (gastosBancarios.length != 0) {
              exportXls = Boolean(true);
            }
          }
          if (exportXls) {
            let title= 'Detalle de Gastos Bancarios';
            let fileName = 'gastos-bancarios';
            let format = [
              { titulo: 'Cuenta', nombre: 'bancoCuenta', formato: '' },
              { titulo: 'Tipo de Movimiento', nombre: 'bancoMovimientoTipo', formato: '' },
              { titulo: 'Fecha', nombre: 'fecha', formato: 'fecha' },
              { titulo: 'Importe', nombre: 'importe', formato: 'importe' },
            ];

            this.exportXLS(title, fileName, gastosBancarios, format);
          } else {
            this.showModalMsj('No hay datos para exportar', null, null, 'light')
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    exportarInversionesBancos(item) {
      let params = {
        fechaDesde: item.fechaDesde,
        fechaHasta: item.fechaHasta,
        totalNegocio: this.totalNegocio
      }
      this.showSpinner();
      this.$store.dispatch('resultadosRentabilidadNeta/getInversionesBancosIndicadorRentabilidadNetaHistorico', params)
        .then(() => {
          let exportXls = Boolean(false); 
          let inversionesBancos = this.$store.getters['resultadosRentabilidadNeta/resultadosIndicadorRentabilidadNeta'];

          if (inversionesBancos) {
            if (inversionesBancos.length != 0) {
              exportXls = Boolean(true);
            }
          }
          if (exportXls) {
            let title= 'Detalle de Inversiones';
            let fileName = 'inversiones-bancos';
            let format = [
              { titulo: 'Cuenta', nombre: 'bancoCuenta', formato: '' },
              { titulo: 'Tipo de Movimiento', nombre: 'bancoMovimientoTipo', formato: '' },
              { titulo: 'Fecha', nombre: 'fecha', formato: 'fecha' },
              { titulo: 'Importe', nombre: 'importe', formato: 'importe' },
            ];

            this.exportXLS(title, fileName, inversionesBancos, format);
          } else {
            this.showModalMsj('No hay datos para exportar', null, null, 'light')
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    exportarImpuestosBancos(item) {
      let params = {
        fechaDesde: item.fechaDesde,
        fechaHasta: item.fechaHasta,
        totalNegocio: this.totalNegocio
      }
      this.showSpinner();
      this.$store.dispatch('resultadosRentabilidadNeta/getImpuestosBancosIndicadorRentabilidadNetaHistorico', params)
        .then(() => {
          let exportXls = Boolean(false); 
          let impuestosBancos = this.$store.getters['resultadosRentabilidadNeta/resultadosIndicadorRentabilidadNeta'];

          if (impuestosBancos) {
            if (impuestosBancos.length != 0) {
              exportXls = Boolean(true);
            }
          }
          if (exportXls) {
            let title= 'Detalle de Impuestos - Bancos';
            let fileName = 'impuestos-bancos';
            let format = [
              { titulo: 'Cuenta', nombre: 'bancoCuenta', formato: '' },
              { titulo: 'Tipo de Movimiento', nombre: 'bancoMovimientoTipo', formato: '' },
              { titulo: 'Fecha', nombre: 'fecha', formato: 'fecha' },
              { titulo: 'Importe', nombre: 'importe', formato: 'importe' },
            ];

            this.exportXLS(title, fileName, impuestosBancos, format);
          } else {
            this.showModalMsj('No hay datos para exportar', null, null, 'light')
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    exportarInteresesPlanesPagosBancos(item) {
      let params = {
        fechaDesde: item.fechaDesde,
        fechaHasta: item.fechaHasta,
        totalNegocio: this.totalNegocio
      }
      this.showSpinner();
      this.$store.dispatch('resultadosRentabilidadNeta/getInteresesPlanesPagosIndicadorRentabilidadNetaHistorico', params)
        .then(() => {
          let exportXls = Boolean(false); 
          let interesesPlanesPagosBancos = this.$store.getters['resultadosRentabilidadNeta/resultadosIndicadorRentabilidadNeta'];

          if (interesesPlanesPagosBancos) {
            if (interesesPlanesPagosBancos.length != 0) {
              exportXls = Boolean(true);
            }
          }
          if (exportXls) {
            let title= 'Detalle de Intereses - Bancos';
            let fileName = 'intereses-planes-bancos';
            let format = [
              { titulo: 'Nro.Plan', nombre: 'planPagosNumero', formato: '' },
              { titulo: 'Cuenta', nombre: 'bancoCuenta', formato: '' },
              { titulo: 'Tipo de Movimiento', nombre: 'bancoMovimientoTipo', formato: '' },
              { titulo: 'Fecha Débito', nombre: 'fechaCreditoDebito', formato: 'fecha' },
              { titulo: 'Importe', nombre: 'importe', formato: 'importe' },
            ];

            this.exportXLS(title, fileName, interesesPlanesPagosBancos, format);
          } else {
            this.showModalMsj('No hay datos para exportar', null, null, 'light')
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    exportarTransferenciasPremios(item) {
      let params = {
        fechaDesde: item.fechaDesde,
        fechaHasta: item.fechaHasta
      }
      this.showSpinner();
      this.$store.dispatch('resultadosRentabilidadNeta/getTransferenciasPremiosIndicadorRentabilidadNetaHistorico', params)
        .then(() => {
          let exportXls = Boolean(false); 
          let transferenciasPremios = this.$store.getters['resultadosRentabilidadNeta/resultadosIndicadorRentabilidadNeta'];

          if (transferenciasPremios) {
            if (transferenciasPremios.length != 0) {
              exportXls = Boolean(true);
            }
          }
          if (exportXls) {
            let title= 'Detalle de Premios-Reembolsos';
            let fileName = 'premios-reembolsos';
            let format = [
              { titulo: 'Cuenta', nombre: 'bancoCuenta', formato: '' },
              { titulo: 'Fecha', nombre: 'fecha', formato: 'fecha' },
              { titulo: 'Importe', nombre: 'importe', formato: 'importe' },
            ];

            this.exportXLS(title, fileName, transferenciasPremios, format);
          } else {
            this.showModalMsj('No hay datos para exportar', null, null, 'light')
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    exportarComprasReembolsos(item) {
      let params = {
        fechaDesde: item.fechaDesde,
        fechaHasta: item.fechaHasta,
        totalNegocio: this.totalNegocio
      }
      this.showSpinner();
      this.$store.dispatch('resultadosRentabilidadNeta/getComprasReembolsosIndicadorRentabilidadNetaHistorico', params)
        .then(() => {
          let exportXls = Boolean(false); 
          let compras = this.$store.getters['resultadosRentabilidadNeta/resultadosIndicadorRentabilidadNeta'];

          if (compras) {
            if (compras.length != 0) {
              exportXls = Boolean(true);
            }
          }
          if (exportXls) {
            let title= 'Detalle de Compras';
            let fileName = 'compras-reembolsos';
            let format = [
              { titulo: 'Proveedor', nombre: 'proveedor', formato: '' },
              { titulo: 'Fecha', nombre: 'fechaComprobante', formato: 'fecha' },
              { titulo: 'Comprobante', nombre: 'comprobante', formato: '' },
              { titulo: 'Moneda', nombre: 'moneda', formato: '' },
              { titulo: 'Total Comprobante Moneda Original', nombre: 'totalComprobante', formato: '' },
              { titulo: 'Total Comprobante Pesos', nombre: 'totalComprobantePesos', formato: '' },
              { titulo: 'Neto Comprobante', nombre: 'montoNetoComprobante', formato: '' },
              { titulo: 'Neto Ordenes Proveedores', nombre: 'montoNetoOrdenesProveedores', formato: '' },
              { titulo: 'Neto Remitos', nombre: 'montoNetoRemitos', formato: '' },
              { titulo: 'Amortización - Años', nombre: 'amortizacionAnios', formato: '' }
            ];

            this.exportXLS(title, fileName, compras, format);
          } else {
            this.showModalMsj('No hay datos para exportar', null, null, 'light')
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    exportarDeudaComercial(item) {
      let params = {
        fechaDesde: item.fechaDesde,
        fechaHasta: item.fechaHasta
      }
      this.showSpinner();
      this.$store.dispatch('resultadosRentabilidadNeta/getDeudaComercialHistorica', params)
        .then(() => {
          let exportXls = Boolean(false); 
          let deudaComercial = this.$store.getters['resultadosRentabilidadNeta/resultadosIndicadorRentabilidadNeta'];

          if (deudaComercial) {
            if (deudaComercial.length != 0) {
              exportXls = Boolean(true);

              deudaComercial = deudaComercial.map(presupuestoInterno => ({
                ...presupuestoInterno,
                saldo: parseFloat(presupuestoInterno.importeVentas) 
                  - parseFloat(presupuestoInterno.importeTransferencias)
                  - parseFloat(presupuestoInterno.importeCompras)
              }))
            }
          }
          if (exportXls) {
            let title= 'Detalle de Deuda Comercial';
            let fileName = 'deuda-comercial';
            let format = [
              { titulo: 'Fecha Registro', nombre: 'fechaRegistro', formato: 'fecha' },
              { titulo: 'Fecha Confirmación', nombre: 'fechaConfirmacion', formato: 'fecha' },
              { titulo: 'Nro.Presupuesto', nombre: 'presupuestoNumero', formato: '' },
              { titulo: 'Cliente', nombre: 'cliente', formato: '' },
              { titulo: 'Accion', nombre: 'accion', formato: '' },
              { titulo: 'Importe Ventas', nombre: 'importeVentas', formato: '' },
              { titulo: 'Importe Transferencias', nombre: 'importeTransferencias', formato: '' },
              { titulo: 'Importe Compras', nombre: 'importeCompras', formato: '' },
              { titulo: 'Saldo', nombre: 'saldo', formato: '' },
            ];

            this.exportXLS(title, fileName, deudaComercial, format);
          } else {
            this.showModalMsj('No hay datos para exportar', null, null, 'light')
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    exportarVentasDeudaComercial(item) {
      let params = {
        fechaDesde: item.fechaDesde,
        fechaHasta: item.fechaHasta
      }

      this.showSpinner();
      this.$store.dispatch('resultadosRentabilidadNeta/getVentasDeudaComercialHistorica', params)
        .then(() => {
          let exportXls = Boolean(false); 
          let deudaComercial = this.$store.getters['resultadosRentabilidadNeta/resultadosIndicadorRentabilidadNeta'];

          if (deudaComercial) {
            if (deudaComercial.length != 0) {
              exportXls = Boolean(true);

              deudaComercial = deudaComercial.map(presupuestoInterno => ({
                ...presupuestoInterno,
                saldo: parseFloat(presupuestoInterno.importeVentas) - parseFloat(presupuestoInterno.importeTransferencias)
              }))
            }
          }
          if (exportXls) {
            let title= 'Detalle de Ventas';
            let fileName = 'deuda-comercial-vtas';
            let format = [
              { titulo: 'Cliente', nombre: 'cliente', formato: '' },
              { titulo: 'Nro.Presupuesto', nombre: 'presupuestoNumero', formato: '' },
              { titulo: 'Accion', nombre: 'accion', formato: '' },
              { titulo: 'Fecha Comp.', nombre: 'fechaComprobante', formato: 'fecha' },
              { titulo: 'Tipo Comprobante', nombre: 'comprobante', formato: '' },
              { titulo: 'Nro Comprobante', nombre: 'numero', formato: '' },
              { titulo: 'Monto Neto', nombre: 'montoNeto', formato: '' },
              { titulo: 'Monto Neto Reembolsos', nombre: 'montoNetoReembolsos', formato: '' },
            ];

            this.exportXLS(title, fileName, deudaComercial, format);
          } else {
            this.showModalMsj('No hay datos para exportar', null, null, 'light')
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    exportarVentasDiferenciasCambio(item) {
      let params = {
        fechaDesde: item.fechaDesde,
        fechaHasta: item.fechaHasta
      }

      this.showSpinner();
      this.$store.dispatch('resultadosRentabilidadNeta/getVentasDiferenciasCambioHistorica', params)
        .then(() => {
          let exportXls = Boolean(false); 
          let diferenciasCambio = this.$store.getters['resultadosRentabilidadNeta/resultadosIndicadorRentabilidadNeta'];

          if (diferenciasCambio) {
            if (diferenciasCambio.length != 0) {
              exportXls = Boolean(true);
            }
          }
          if (exportXls) {
            let title= 'Detalle de Ventas';
            let fileName = 'vtas-diferencias-cambio';
            let format = [
              { titulo: 'Cliente', nombre: 'cliente', formato: '' },
              { titulo: 'Fecha Comp.', nombre: 'fechaComprobante', formato: 'fecha' },
              { titulo: 'Comprobante', nombre: 'comprobante', formato: '' },
              { titulo: 'Moneda', nombre: 'moneda', formato: '' },
              { titulo: 'Total Comprobante', nombre: 'totalComprobante', formato: '' },
              { titulo: 'Cotizacion Comprobante', nombre: 'cotizacionComprobante', formato: '' },
              { titulo: 'Fecha Cobro', nombre: 'fechaCobro', formato: 'fecha' },
              { titulo: 'Nro.Cobro', nombre: 'cobroId', formato: '' },
              { titulo: 'Importe Cobro', nombre: 'importeCobro', formato: '' },
              { titulo: 'Cotizacion Cobro', nombre: 'cotizacionCobro', formato: '' },
              { titulo: 'Dif.Cotizaciones', nombre: 'diferenciaCotizacion', formato: '' },
              { titulo: 'Dif.Cambio', nombre: 'diferenciaCambio', formato: '' },
            ];

            this.exportXLS(title, fileName, diferenciasCambio, format);
          } else {
            this.showModalMsj('No hay datos para exportar', null, null, 'light')
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    exportarComprasDiferenciasCambio(item) {
      let params = {
        fechaDesde: item.fechaDesde,
        fechaHasta: item.fechaHasta
      }

      this.showSpinner();
      this.$store.dispatch('resultadosRentabilidadNeta/getComprasDiferenciasCambioHistorica', params)
        .then(() => {
          let exportXls = Boolean(false); 
          let diferenciasCambio = this.$store.getters['resultadosRentabilidadNeta/resultadosIndicadorRentabilidadNeta'];

          if (diferenciasCambio) {
            if (diferenciasCambio.length != 0) {
              exportXls = Boolean(true);
            }
          }
          if (exportXls) {
            let title= 'Detalle de Compras';
            let fileName = 'compras-diferencias-cambio';
            let format = [
              { titulo: 'Proveedor', nombre: 'proveedor', formato: '' },
              { titulo: 'Fecha Comp.', nombre: 'fechaComprobante', formato: 'fecha' },
              { titulo: 'Comprobante', nombre: 'comprobante', formato: '' },
              { titulo: 'Moneda', nombre: 'moneda', formato: '' },
              { titulo: 'Total Comprobante', nombre: 'totalComprobante', formato: '' },
              { titulo: 'Cotizacion Comprobante', nombre: 'cotizacionComprobante', formato: '' },
              { titulo: 'Fecha Pago', nombre: 'fechaPago', formato: 'fecha' },
              { titulo: 'Nro.Pago', nombre: 'numeroPago', formato: '' },
              { titulo: 'Importe Pago', nombre: 'importePago', formato: '' },
              { titulo: 'Cotizacion Pago', nombre: 'cotizacionPago', formato: '' },
              { titulo: 'Dif.Cotizaciones', nombre: 'diferenciaCotizacion', formato: '' },
              { titulo: 'Dif.Cambio', nombre: 'diferenciaCambio', formato: '' },
            ];

            this.exportXLS(title, fileName, diferenciasCambio, format);
          } else {
            this.showModalMsj('No hay datos para exportar', null, null, 'light')
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
  }
}
</script>

<style>
  .dashboard-indicadores-historico-rentabilidad-neta .registro table td[aria-colindex="1"] {
    width: 30px !important;
  }
  .dashboard-indicadores-historico-rentabilidad-neta .registro table td[aria-colindex="2"] {
    width: 21% !important;
  }
  .dashboard-indicadores-historico-rentabilidad-neta .registro table td[aria-colindex="3"] {
    width: 10% !important;
  }
  .dashboard-indicadores-historico-rentabilidad-neta .registro table td[aria-colindex="4"],
  .dashboard-indicadores-historico-rentabilidad-neta .registro table td[aria-colindex="5"] {
    width: 12% !important;
  }
  .dashboard-indicadores-historico-rentabilidad-neta .registro table td[aria-colindex="6"] {
    width: 10% !important;
  }
  .dashboard-indicadores-historico-rentabilidad-neta .registro table td[aria-colindex="7"] {
    width: 12% !important;
  }
  .dashboard-indicadores-historico-rentabilidad-neta .registro table td[aria-colindex="8"] {
    width: calc(25% - 90px) !important;
  }
  .dashboard-indicadores-historico-rentabilidad-neta .registro table td[aria-colindex="9"] {
    width: 60px !important;
  }

  .dashboard-indicadores-historico-rentabilidad-neta .registro table tr.b-table-details td {
    padding-left: 30px;
    padding-bottom: 30px;
  }
  .dashboard-indicadores-historico-rentabilidad-neta .registro table tr.b-table-details td .row {
    margin-bottom: 0px !important;
  }
  .dashboard-indicadores-historico-rentabilidad-neta .registro table tr.b-table-details td .row p {
    margin-bottom: 5px !important;
  }

</style>